var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg13(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.6667 2.66675H1.66669V21.3334C1.66669 25.0153 4.65146 28.0001 8.33335 28.0001H27C24.0545 28.0001 21.6667 25.6123 21.6667 22.6667V2.66675ZM5.66669 10.6667C5.66669 9.19399 6.86059 8.00008 8.33335 8.00008H17.6667V8.66675C17.6667 10.1395 16.4728 11.3334 15 11.3334H5.66669V10.6667ZM8.33335 14.6667C6.86059 14.6667 5.66669 15.8607 5.66669 17.3334V18.0001H9.66669C11.1394 18.0001 12.3334 16.8062 12.3334 15.3334V14.6667H8.33335Z",
    fill: "#FAB215"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M21.6667 17.3335H31V23.852C31 26.143 29.1428 28.0002 26.8519 28.0002C23.9882 28.0002 21.6667 25.6787 21.6667 22.815V17.3335Z",
    fill: "#FAB215"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg13);
export default __webpack_public_path__ + "static/media/13.e34f921bb3ae3db923b45feede63adc3.svg";
export { ForwardRef as ReactComponent };